'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var defaultStyles = {};

exports.default = function (_ref) {
  var style = _ref.style,
      className = _ref.className;
  var customStyles = Object.assign({}, defaultStyles, style);
  return _react2.default.createElement('svg', {
    style: customStyles,
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
    xmlns: 'http://www.w3.org/2000/svg',
    className: className ? className + ' icon icon-user' : 'icon icon-user'
  }, _react2.default.createElement('g', {
    id: 'create-new-project_new-layout'
  }, _react2.default.createElement('g', {
    id: '_x31_11.1-Menu_x5F_landing',
    transform: 'translate(-1113.000000, -25.000000)'
  }, _react2.default.createElement('g', {
    id: 'fa-user-',
    transform: 'translate(1115.000000, 26.000000)'
  }, _react2.default.createElement('g', {
    id: 'Group-9'
  }, _react2.default.createElement('path', {
    fill: 'currentColor',
    d: 'M6,14c-1.2,0-2.4,0-3.6,0c-1.5,0.1-2.2-0.9-2.3-1.9c-0.2-1.4,0-2.8,0.7-4.1 c0.4-0.7,1-1.2,1.9-1.4c0.2,0,0.4,0,0.7,0.2c1.6,1.3,3.8,1.3,5.4,0c0.2-0.2,0.4-0.2,0.6-0.1c0.9,0.1,1.5,0.6,1.9,1.3 c0.5,0.9,0.7,1.9,0.7,2.9c0,0.6,0.1,1.3-0.2,1.9c-0.4,0.8-1,1.2-2,1.2C8.5,14,7.3,14,6,14'
  }), _react2.default.createElement('path', {
    fill: 'currentColor',
    d: 'M9.4,3.8c0,2.1-1.6,3.7-3.5,3.6C4,7.4,2.5,5.7,2.6,3.6c0-2.1,1.6-3.6,3.5-3.6 C8,0.1,9.5,1.8,9.4,3.8'
  }))))));
};